import React, { useEffect, useRef, useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { CSVLink } from "react-csv";
import { exportToExcel } from "./exportToExcel";
import { Dropdown, Spinner } from "react-bootstrap";
import { withRouter } from "../../../App";
import { connect, useDispatch } from "react-redux";
import { getCandidates } from "../../../store/selectors/Candidates/CandidatesList";
import { getCandidates as getCandidatesAction } from "../../../store/actions/Candidates/candidateActions";
import { dateFormat, isPastDate } from "../../../utils/date";
import swal from "sweetalert";
import { toast } from "react-toastify";
import { del, get, post } from "../../../services/api";
import { getLoggenInToken, getLoggedInUser } from "../../../store/selectors/AuthSelectors";
import EditCandidate from "./EditCandidate";
import Status from "../Common/Status";
import SendEmail from "../Common/SendEmail"
import SendLetter from "../Common/SendLetter"
import CandidateDetails from "./CandidateDetails";
import CandidateClassification from "./CandidateClassification";
import dayjs from "dayjs";
import { useMsal, useIsAuthenticated } from "@azure/msal-react";
import { InteractionRequiredAuthError } from "@azure/msal-browser";
import { loginRequest } from "../../../authConfig";

const headersTitle = [
  { label: "First Name", key: "firstName" },
  { label: "Last Name", key: "lastName" },
  { label: "Email", key: "email" },
  { label: "Office", key: "office" },
  { label: "Registration Date", key: "regDate" },
  { label: "Status", key: "status" },
];

const ListTab = ({ title, candidates, token, loggedInUser }) => {
  const userdata = useRef();
  const sendletterref = useRef();
  const { instance, accounts } = useMsal();
  const isAuthenticated = useIsAuthenticated();
  const [sendingKidId, setSendingKidId] = useState(null);
  const nav = useNavigate();
  const location = useLocation();
  const editCandidateRef = useRef();
  const candidateDetailsRef = useRef();
  const candidateClassificationRef = useRef();
  const dispatch = useDispatch();
  const [selectedCandidate, setSelectedCandidate] = useState({});
  const [currentPage, setCurrentPage] = useState(1);
  const [searchQuery, setSearchQuery] = useState(""); // Search query state
  const [companyCandidateIds, setCompanyCandidateIds] = useState(new Set());
  const [isSearching, setIsSearching] = useState(false);
  const recordsPage = 10;
  const handleEmailAction = (action) => {
    if (isAuthenticated) {
      action();
    } else {
      swal({
        title: "Email Not Synced",
        text: "Please sync your email first.",
        icon: "warning",
        buttons: {
          cancel: "Cancel",
          sync: {
            text: "Sync Email",
            value: "sync",
          },
        },
      }).then((value) => {
        if (value === "sync") {
          instance.loginPopup(loginRequest).catch((e) => {
            console.error(e);
          });
        }
      });
    }
  };

  // Check if a candidate is recently added (from today onwards)
  const isRecentlyAdded = (candidate) => {
    if (!candidate.regDate) return false;
    const regDate = new Date(candidate.regDate);
    const today = new Date();
    today.setHours(0, 0, 0, 0); // Set to start of today
    
    // Check if regDate is today or later
    return regDate >= today;
  };

  // Check if candidate should show Send KID button
  const shouldShowSendKid = (candidate) => {
    return candidate.consultant === "Rapid Resourcing" && !candidate.kidSentAt && isRecentlyAdded(candidate);
  };

  // Handle Send KID button click
  const handleSendKid = (candidate) => {
    if (!isAuthenticated) {
      swal({
        title: "Email Not Synced",
        text: "Please sync your email first to send KID.",
        icon: "warning",
        buttons: {
          cancel: "Cancel",
          sync: {
            text: "Sync Email",
            value: "sync",
          },
        },
      }).then((value) => {
        if (value === "sync") {
          instance.loginPopup(loginRequest).catch((e) => {
            console.error(e);
          });
        }
      });
      return;
    }

    swal({
      title: "Send KID",
      text: `Send Key Information Document to ${candidate.firstName} ${candidate.lastName} (${candidate.email})?`,
      icon: "info",
      buttons: {
        cancel: "Cancel",
        confirm: {
          text: "Send KID",
          value: true,
        },
      },
    }).then(async (willSend) => {
      if (willSend) {
        try {
          setSendingKidId(candidate._id);
          // Acquire access token for Microsoft Graph
          let tokenResponse;
          try {
            tokenResponse = await instance.acquireTokenSilent({
              ...loginRequest,
              account: accounts[0],
            });
          } catch (silentError) {
            if (silentError instanceof InteractionRequiredAuthError) {
              // Session expired or missing — fall back to interactive popup
              tokenResponse = await instance.acquireTokenPopup({
                ...loginRequest,
                account: accounts[0],
              });
            } else {
              throw silentError;
            }
          }

          const res = await post(
            `/api/candidate/send-kid/${candidate._id}`,
            { accessToken: tokenResponse.accessToken },
            token
          );

          if (res.status === 200) {
            toast.success("KID sent successfully to " + candidate.email);
          } else {
            toast.error("Failed to send KID. Please try again.");
          }
        } catch (error) {
          console.error("Error sending KID:", error);
          toast.error("Failed to send KID. Please try again.");
        } finally {
          setSendingKidId(null);
        }
      }
    });
  };


  const lastIndex = currentPage * recordsPage;
  const firstIndex = lastIndex - recordsPage;
  const npage = Math.ceil(candidates?.length / recordsPage);
  const number = [...Array(npage + 1).keys()].slice(1);

  function prePage() {
    if (currentPage !== 1) {
      setCurrentPage(currentPage - 1);
    }
  }

  function changeCPage(id) {
    setCurrentPage(id);
  }

  function nextPage() {
    if (currentPage !== npage) {
      setCurrentPage(currentPage + 1);
    }
  }

  const [checked, setChecked] = useState([]);
  const [unchecked, setUnChecked] = useState(true);

  // Helper function to reload and navigate while preserving history
  const handleRefreshAndNavigate = (url) => {
    // Force a page reload by navigating to the target URL directly
    // This causes a reload and preserves browser history
    window.location.href = url;
  };

  useEffect(() => {
    setChecked(
      
      candidates?.slice(firstIndex, lastIndex).map((candidate) => ({
        ...candidate,
        inputchecked: false,
      }))
    );
  }, [candidates, currentPage])

  useEffect(() => {
    const filteredCandidates = candidates?.filter((candidate) => {
      const dobFormatted = dayjs(candidate.dateOfBirth).format("DD-MM-YYYY");
      const q = searchQuery.toLowerCase();
      return (
        candidate.firstName?.toLowerCase().includes(q) ||
        candidate.lastName?.toLowerCase().includes(q) ||
        candidate.email?.toLowerCase().includes(q) ||
        dobFormatted.includes(searchQuery) ||
        companyCandidateIds.has(String(candidate._id))
      );
    });
    setChecked(filteredCandidates);
  }, [searchQuery, candidates, companyCandidateIds]);

  useEffect(() => {
    setCurrentPage(1); // Reset to first page on data update
  }, [candidates, searchQuery]);



  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const q = params.get("search");
    if (q) setSearchQuery(q);
  }, []);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    if (searchQuery && searchQuery.trim().length > 0) {
      params.set("search", searchQuery);
    } else {
      params.delete("search");
    }
    nav(`${location.pathname}${params.toString() ? `?${params.toString()}` : ""}`, { replace: true });
  }, [searchQuery]);

  // Fetch candidates matched by company name and maintain their IDs
  useEffect(() => {
    let cancelled = false;
    let timeoutId;
    if (!searchQuery || searchQuery.trim().length === 0) {
      setCompanyCandidateIds(new Set());
      setIsSearching(false);
      return () => {};
    }
    setIsSearching(true);
    timeoutId = setTimeout(async () => {
      try {
        const data = await get(
          `/api/company/candidates/by-name/${encodeURIComponent(searchQuery)}`,
          token
        );
        if (cancelled) return;
        const idSet = new Set((data || []).map((c) => String(c._id)));
        setCompanyCandidateIds(idSet);
      } catch (e) {
        if (!cancelled) setCompanyCandidateIds(new Set());
      } finally {
        if (!cancelled) setIsSearching(false);
      }
    }, 500); // debounce delay

    return () => {
      cancelled = true;
      clearTimeout(timeoutId);
    };
  }, [searchQuery, token]);

  const handleChecked = (id) => {
    setChecked((prevChecked) =>
      prevChecked.map((candidate) =>
        candidate._id === id
          ? { ...candidate, inputchecked: !candidate.inputchecked }
          : candidate
      )
    );
  };

  const handleCheckedAll = (value) => {
    let temp = checked.map((data) => {
      return { ...data, inputchecked: value };
    });
    setChecked(temp);
    setUnChecked(!unchecked);
  };

  return (
    <>
      <div className="card">
        <div className="card-body p-0">
          <div className="table-responsive active-projects style-1 ItemsCheckboxSec shorting">
            <div className="tbl-caption">
              <h4 className="heading mb-0">{title}</h4>
              <div>
                <button
                  className="btn btn-primary btn-sm me-2"
                  onClick={() =>
                    handleEmailAction(() => userdata.current.showEmailModal())
                  }
                  disabled={checked.filter((d) => d.inputchecked)?.length === 0}
                >
                  <i className="fa-solid fa-envelope me-2"></i>
                  Send Mail
                </button>
                <button
                  className="btn btn-primary btn-sm me-2"
                  onClick={() =>
                    handleEmailAction(() =>
                      sendletterref.current.showLetterModal()
                    )
                  }
                  disabled={checked.filter((d) => d.inputchecked)?.length === 0}
                >
                  <i className="fa-solid fa-envelope me-2"></i>
                  Send Letter
                </button>
                <button
                  onClick={() =>
                    exportToExcel(
                      checked.filter((itm) => itm.inputchecked).length > 0
                        ? checked.filter((itm) => itm.inputchecked)
                        : candidates
                    )
                  }
                  className="btn btn-primary light btn-sm me-2"
                >
                  <i className="fa-solid fa-file-excel" /> Export Report
                </button>
              </div>
            </div>
            <div className="p-2 d-flex align-items-center">
              <input
                type="text"
                className="form-control form-control-sm me-2 w-70"
                placeholder="Search by First Name, Last Name, Email, DOB(dd-mm-yyyy) or Company"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
              />
            </div>
            {isSearching ? (
              <div className="text-center my-4">
                <Spinner animation="border" variant="primary" />
              </div>
            ) : (
            <div id="user-tbl_wrapper" className="dataTables_wrapper no-footer">
              <table
                id="projects-tbl"
                className="table ItemsCheckboxSec dataTable no-footer mb-2 mb-sm-0"
              >
                <thead>
                  <tr>
                    <th className="sorting_asc_11">
                      <div className="form-check custom-checkbox ms-0">
                        <input
                          type="checkbox"
                          className="form-check-input checkAllInput"
                          onClick={() => handleCheckedAll(unchecked)}
                        />
                        <label
                          className="form-check-label"
                          htmlFor="checkAll"
                        ></label>
                      </div>
                    </th>
                    <th>Title</th>
                    <th>First Name</th>
                    <th>Last Name</th>
                    <th>Email</th>
                    <th>Registration Date</th>
                    <th>Status</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {console.log(checked)}
                  {checked.map((item, index) => (
                    <tr
                      key={index}
                      className={
                        (item.nationality !== "United Kingdom" &&
                        item.nationality !== "Ireland" &&
                        item.visaType === "STUDENT")
                          ? "table-warning"
                          : (item.visaExpiry && isPastDate(item.visaExpiry)) ? "table-danger" : ""
                      }
                    >
                      <td className="sorting_20">
                        <div className="form-check11custom-checkbox">
                          <input
                            type="checkbox"
                            className="form-check-input"
                            id={`user-${item._id}`}
                            checked={item.inputchecked}
                            onChange={() => handleChecked(item._id)}
                          />
                          <label
                            className="form-check-label"
                            htmlFor={`user-${item._id}`}
                          ></label>
                        </div>
                      </td>
                      <td>
                        <div className="d-flex align-items-center">
                          <p className="mb-0 ms-2">{item.title}</p>
                        </div>
                      </td>
                      <td>{item.firstName}</td>
                      <td>{item.lastName}</td>
                      <td>{item.email}</td>
                      <td>{dateFormat(item.regDate)}</td>
                      <td>
                        <Status status={item.status} />
                      </td>
                      <td>
                        {/* <Dropdown> */}
                        {/* <Dropdown.Toggle
                            as="div"
                            className="btn-link i-false"
                          >
                            ...
                          </Dropdown.Toggle> */}
                        {/* <Dropdown.Menu className="dropdown-menu-right" align="end">
                            <Dropdown.Item onClick={() => nav(`/add-candidate?id=${item._id}&mode=view`)}>
                              View
                            </Dropdown.Item>
                            <Dropdown.Item onClick={() => nav(`/add-candidate?id=${item._id}&mode=edit`)}>
                              Edit
                            </Dropdown.Item>
                            <Dropdown.Item
                              onClick={() =>
                                swal({
                                  title: "Are you sure?",
                                  text: "Once deleted, you will not be able to recover this candidate!",
                                  icon: "warning",
                                  buttons: true,
                                  dangerMode: true,
                                }).then(async (willDelete) => {
                                  if (willDelete) {
                                    await del(
                                      "/api/candidate/" + item?._id,
                                      token
                                    );
                                    toast.success(
                                      "Candidate deleted successfully."
                                    );
                                    dispatch(getCandidatesAction(token));
                                  }
                                })
                              }
                            >
                              Delete
                            </Dropdown.Item>
                          </Dropdown.Menu> */}

                        {/* <Dropdown.Menu className="dropdown-menu-right" align="end">
                            <Dropdown.Item onClick={() => nav(`/add-candidate?id=${item._id}&mode=view`)}>
                              <i class="bi bi-eye"></i>
                            </Dropdown.Item>
                            <Dropdown.Item onClick={() => nav(`/add-candidate?id=${item._id}&mode=edit`)}>
                              <i class="bi bi-pen"></i>
                            </Dropdown.Item>
                            <Dropdown.Item
                              onClick={() =>
                                swal({
                                  title: "Are you sure?",
                                  text: "Once deleted, you will not be able to recover this candidate!",
                                  icon: "warning",
                                  buttons: true,
                                  dangerMode: true,
                                }).then(async (willDelete) => {
                                  if (willDelete) {
                                    await del(
                                      "/api/candidate/" + item?._id,
                                      token
                                    );
                                    toast.success(
                                      "Candidate deleted successfully."
                                    );
                                    dispatch(getCandidatesAction(token));
                                  }
                                })
                              }
                            >
                              
                             <i class="bi bi-trash"></i>
                            </Dropdown.Item>
                          </Dropdown.Menu> */}
                        {/* </Dropdown> */}
                        <div className="action-buttons">
                          {/* Send KID Button - only for recently added Rapid Resourcing candidates */}
                          {shouldShowSendKid(item) && (
                            <button
                              className="btn btn-link text-success"
                              title="Send KID"
                              disabled={sendingKidId === item._id}
                              onClick={() => handleSendKid(item)}
                            >
                              {sendingKidId === item._id ? (
                                <Spinner animation="border" size="sm" />
                              ) : (
                                <i className="fa-solid fa-paper-plane"></i>
                              )}
                            </button>
                          )}

                          {/* View Candidate Button */}
                          <button
                            className="btn btn-link"
                            onClick={() =>
                              handleRefreshAndNavigate(`/add-candidate?id=${item._id}&mode=view`)
                            }
                          >
                            <i className="bi bi-eye"></i>
                          </button>

                          {/* Edit Candidate Button */}
                          <button
                            className="btn btn-link"
                            onClick={() =>
                              handleRefreshAndNavigate(`/add-candidate?id=${item._id}&mode=edit`)
                            }
                          >
                            <i className="bi bi-pen"></i>
                          </button>

                          {/* Delete Candidate Button */}
                          <button
                            className="btn btn-link text-danger"
                            onClick={() =>
                              swal({
                                title: "Are you sure?",
                                text: "Once deleted, you will not be able to recover this candidate!",
                                icon: "warning",
                                buttons: true,
                                dangerMode: true,
                              }).then(async (willDelete) => {
                                if (willDelete) {
                                  await del(
                                    `/api/candidate/${item?._id}`,
                                    token
                                  );
                                  toast.success(
                                    "Candidate deleted successfully."
                                  );
                                  dispatch(getCandidatesAction(token));
                                }
                              })
                            }
                          >
                            <i className="bi bi-trash"></i>
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
              <div className="d-sm-flex text-center justify-content-between align-items-center">
                <div className="dataTables_info">
                  Showing {lastIndex - recordsPage + 1} to {lastIndex} of{" "}
                  {candidates.length} entries
                </div>
                <div
                  className="dataTables_paginate paging_simple_numbers justify-content-center"
                  id="example2_paginate"
                >
                  <Link
                    className="paginate_button previous disabled"
                    to="#"
                    onClick={prePage}
                  >
                    <i className="fa-solid fa-angle-left" />
                  </Link>
                  <span>
                    {number.map((n, i) => (
                      <Link
                        className={`paginate_button ${
                          currentPage === n ? "current" : ""
                        } `}
                        key={i}
                        onClick={() => changeCPage(n)}
                      >
                        {n}
                      </Link>
                    ))}
                  </span>
                  <Link
                    className="paginate_button next"
                    to="#"
                    onClick={nextPage}
                  >
                    <i className="fa-solid fa-angle-right" />
                  </Link>
                </div>
              </div>
            </div>
            )}
          </div>
        </div>
      </div>
      <EditCandidate
        ref={editCandidateRef}
        candidate={selectedCandidate}
        Title="Edit Candidate"
        token={token}
      />
      <CandidateDetails
        ref={candidateDetailsRef}
        candidate={selectedCandidate}
        Title="Candidate Details"
        token={token}
      />
      <CandidateClassification
        ref={candidateClassificationRef}
        candidate={selectedCandidate}
        Title="Candidate Classification"
        token={token}
      />
      <SendEmail
        ref={userdata}
        Title="Send Email"
        token={token}
        data={checked.filter((d) => d.inputchecked)}
        user={loggedInUser}

        //hint={"Please use #title#, #firstName# , #lastName# to dynamically map values"}
      />
      <SendLetter
        ref={sendletterref}
        token={token}
        data={checked.filter((d) => d.inputchecked)}
        isCompany={false}
        user={loggedInUser}
      />
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    candidates: getCandidates(state),
    token: getLoggenInToken(state),
    loggedInUser: getLoggedInUser(state),
  };

};

export default withRouter(connect(mapStateToProps)(ListTab));
